import React from 'react';
import './toggleSwitch.scss';
import { useTheme } from '@material-ui/core';

type ToggleSwitchProps = {
  options: any[];
  isTrue: boolean;
  toggleIsEnabled: Function;
};

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  options,
  isTrue,
  toggleIsEnabled
}) => {
  const theme = useTheme() as any;

  return (
    <div className="switch-container">
      {options.map(option => {
        return (
          <div
            key={option.text}
            className="switch-option"
            style={{
              backgroundColor:
                isTrue === option.value
                  ? theme.palette.primary.main
                  : '#CECCCC',
              color: isTrue === option.value ? 'white' : '#2f2f2f80'
            }}
            onClick={() => toggleIsEnabled(option.value)}
          >
            {option.text}
          </div>
        );
      })}
    </div>
  );
};

export default ToggleSwitch;
